/**
 * Type guard that checks if a collection is not null/undefined and contains at least one item.
 * @param value The collection to check.
 * @returns true if the collection exists and has items; otherwise, false.
 */
export default function collectionHasItems<T>(value: T[] | null | undefined): value is T[] & { length: number } {
	return value != null && value.length > 0;
}
